console.log('loading web-client.js');


class WebClient {
	constructor() {
		this.name = 'webclient';
		
		this.global = null; // put by global on registration
		this.isready = false;
		this.isloading = false;

		this.globalscope = window;
		
		this.execution_env = ( (typeof WebClient.EXEC_ENV !== 'undefined') ? WebClient.EXEC_ENV : 'prod');
		
		var WebClientConfig = require('./webclient-config.js');

		if ((WebClientConfig.execution_env == 'dev') || (this.execution_env == 'dev')) {
			this.execution_env = 'dev';
		}

		this.WebClientConfig = WebClientConfig;

		var WebClientControllers = require('./control/controllers.js').default;
		
		this.webclientcontrollers = WebClientControllers.getObject();
		
		this.webclientcontrollers.module = this;

		this.currencies = null;
	}

	async init() {
		console.log('WebClient.init called');
		console.log('module init called for ' + this.name);
		
		try {
			var _globalscope = this.globalscope;

			var webclientcontrollers_init = await this.webclientcontrollers.init()
			.catch((err) => {
				console.log('error initializing web client controllers: ' + err);
			});
			
			console.log('webclient controllers initialized');			
			
			// end of all initialization
			var Bootstrap = _globalscope.simplestore.Bootstrap;
			var ScriptLoader = _globalscope.simplestore.ScriptLoader;

			var bootstrapobject = Bootstrap.getBootstrapObject();
			var rootscriptloader = ScriptLoader.getRootScriptLoader();
			
			// ethereum_core is now set
			var clientglobal = _globalscope.simplestore.Global.getGlobalObject();
			
			// register this module
			clientglobal.registerModuleObject(this);

			// ethereum_core config
			var clientglobal = _globalscope.simplestore.Global.getGlobalObject();
			var CoreConfig = _globalscope.simplestore.Config;
			
			var XtraConfig = _globalscope.simplestore.Config.XtraConfig;
			
			if (!XtraConfig.instance)
				XtraConfig.instance = new XtraConfig();


			var WebClientConfig = this.WebClientConfig;

			var clientapicontrollers = this.getClientAPI();

			// get session object
			var session = clientapicontrollers.getCurrentSessionObject();

 			//
			// built-in environment
			//

			/*
			// create built-in schemes

			// local schemes
			var _builtin_local_schemes = this.getBuiltinLocalSchemes();
			if (_builtin_local_schemes) {
				var network_list = Object.values(_builtin_local_schemes);
				console.log('WebClient.init starting creating local schemes');
				for (var i = 0; i < network_list.length; i++) {
					var prodnetwork = network_list[i];
					var scheme = await clientapicontrollers.createScheme(session, prodnetwork);
				}
			}

			// remote schemes
			var _builtin_remote_schemes = this.getBuiltinRemoteSchemes();
			if (_builtin_remote_schemes) {
				var network_list = Object.values(_builtin_remote_schemes);
				console.log('WebClient.init starting creating remote schemes');
				for (var i = 0; i < network_list.length; i++) {
					var prodnetwork = network_list[i];
					var scheme = await clientapicontrollers.createScheme(session, prodnetwork);
				}
			} */


			//
			// memory environment
			//
	

			// load currencies
			
			var currencies = this.getCurrencies(); // built-in

			// local currencies for the user
			var currenciesmodule = clientglobal.getModuleObject('currencies');

			var local_currencies = await currenciesmodule.readLocalCurrencies(session)
			.catch(err => {
				console.log('WebClient.init error reading local currencies: ' + err);
			});

			if (local_currencies) {
				for (var i = 0; i < (local_currencies ? local_currencies.length : 0); i++) {
					var key = local_currencies[i].uuid;

					currencies[key] = local_currencies[i];
				}
			}
			
				
			// we fill currencies in the currencies module

			if (currenciesmodule) {
				var currencies_array = Object.values(currencies);
	
				for (var i = 0; i < currencies_array.length; i++) {
					currenciesmodule.addCurrency(currencies_array[i]);
				}
			}
			else {
				console.log('Warning: you must load currencies module before calling WebClient.init');
			}


			//signal end of client load
			rootscriptloader.signalEvent('on_client_load_end');
			
			this.isready = true;			
			
			return true;
		}
		catch(e) {
			console.log('exception in WebClient.init: ' + e);
		}	
	}


	// compulsory  module functions
	loadModule(parentscriptloader, callback) {
		console.log('loadModule called for module ' + this.name);
		
		if (this.isloading)
			return;
			
		this.isloading = true;

		var self = this;

		var modulescriptloader = parentscriptloader.getChildLoader('webclientmoduleloader');

		modulescriptloader.load_scripts(function() { 
			//self.init(); // init is called by index.js
			if (callback) callback(null, self); 
		});

		return modulescriptloader;	
	}
	
	isReady() {
		return this.isready;
	}

	hasLoadStarted() {
		return this.isloading;
	}

	// optional  module functions
	registerHooks() {
		console.log('module registerHooks called for ' + this.name);
		
		var global = this.global;
		
		global.registerHook('cleanSessionContext_hook', this.name, this.cleanSessionContext_hook);
		
		global.registerHook('getDefaultSchemeConfig_hook', this.name, this.getDefaultSchemeConfig_hook);
	}
	
	postRegisterModule() {
		console.log('postRegisterModule called for ' + this.name);
		if (!this.isloading) {
			var global = this.global;
			var self = this;
			var rootscriptloader = global.getRootScriptLoader();
			
			this.loadModule(rootscriptloader, () => {
				if (this.registerHooks)
				this.registerHooks();
			});
		}
	}

	getDefaultSchemeConfig_hook(result, params) {
		console.log('getDefaultSchemeConfig_hook called for ' + this.name);
		
		var global = this.global;
		

		
		result.push({module: this.name, handled: true});
		
		return true;
	}

	cleanSessionContext_hook(result, params) {
		console.log('cleanSessionContext_hook called for ' + this.name);
		
		var global = this.global;
		
		var session = params[0];
		
		// we clean the child sessions
		var clientapicontrollers = this.getClientAPI();
		clientapicontrollers.cleanChildSessionObjects(session);
		
		result.push({module: this.name, handled: true});
		
		return true;
	}

	// built-in
	getBuiltinCurrencies() {
		return require('./currencies.js');
	}
	
	getBuiltinLocalSchemes() {
		return this.WebClientConfig.builtin_local_schemes;
	}

	getBuiltinRemoteSchemes() {
		return this.WebClientConfig.builtin_remote_schemes;
	}

	getCurrencies() {
		if (this.currencies)
			return this.currencies;

		this.currencies = this.getBuiltinCurrencies();

		return this.currencies;
	}


	// web functions
	getWebControllers() {
		return this.webclientcontrollers;
	}
	
	getClientControllers() {
		return this.webclientcontrollers;
	}

	getClientAPI() {
		var webclientcontrollers = this.webclientcontrollers;
		var clientapicontrollers = webclientcontrollers.getClientControllers();

		return clientapicontrollers;
	}

	getExecutionEnvironment() {
		if (this.execution_env)
			return this.execution_env;
		else
			return 'prod';
	}


	// static functions
	static getObject() {
		if (WebClient.webclient)
			return WebClient.webclient;
		
		WebClient.webclient = new WebClient();

		return WebClient.webclient;
	}
}

//module.exports = WebClient;
// Note: webpack does not handle well import on module.exports
export default WebClient;
